import { Either } from "core/types/Either";
import {
  AppleWalletPass,
  GoogleWalletPass,
  WalletPassParams,
} from "domain/entity/WalletPass";

export abstract class WalletRepository {
  abstract getAppleWalletPass(
    params: WalletPassParams
  ): Promise<Either<Error, AppleWalletPass>>;

  abstract getGoogleWalletPass(
    params: WalletPassParams
  ): Promise<Either<Error, GoogleWalletPass>>;
}
